function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 48,
  r: 48,
  fill: "#7D94E3"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M60.819 36H35.18c-1.619 0-2.931 1.292-2.931 2.885 0 .965.49 1.866 1.305 2.401l1.778 1.167 10.17 6.674c.19.124.386.232.587.325 1.41.651 3.084.543 4.406-.325l10.171-6.674 1.778-1.167c.815-.535 1.305-1.436 1.305-2.4 0-1.594-1.312-2.886-2.931-2.886zM32 46.045c0-.324.034-.64.1-.945.182-.86 1.235-1.083 1.99-.595l9.916 6.407c2.419 1.562 5.57 1.562 7.988 0l9.917-6.407c.754-.488 1.807-.265 1.99.595.065.305.099.621.099.945V56.9C64 58.612 62.567 60 60.8 60H35.2c-1.767 0-3.2-1.388-3.2-3.101V46.045z"
}));

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.14c03d53.svg";
export { ForwardRef as ReactComponent };